<template>
    <div>
        <BaseModal 
            v-if="visible"
            ModalId="modalId"
            :HideModalFun="onHidden"
            :TitleWindow="editMode ? $t('eItemsReceivedEdit.EditTitle') : $t('eItemsReceivedEdit.AddTitle')"
            :width="'50%'"
            :height="'auto'"
            :buttons="[
                { text: $t('Shared.BtnCancel'), variant: 'secondary', action: 'Close' },
                { text: $t('Shared.TitleOK'), variant: 'primary', action: emitEventOK },                   
            ]"              
            @Close="close"
        >
        <MdTitle v-bind:Text="$t('ePharmacyItemsReceived.Total')+' $' + Total + ' - ' + $t('ePharmacyItemsReceived.MinOrder')+' '+MinOrder" v-bind:StyleProp="'margin: -1em 0 0.7em 0'" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'" />
        
            <b-row>
                <b-col lg="4" md="4" sm="12">
                    <MdLookup
                        v-bind:Label="$t('eItemsReceivedEdit.ItemCode')"
                        v-bind:ModelCode="item.itemCode"
                        v-bind:ModelDescription="item.description"
                        v-bind:Api="'ItemReceivedHeaders/InvetoryItems'"
                        v-bind:FieldCode="'itemCode'"
                        v-bind:FieldDescription="'description'"
                        v-bind:Fields="drugBaseFields"
                        v-bind:AuxFields="drugAuxFields"
                        v-bind:RefCode="'itemCode'"
                        v-bind:isRequired="true"
                        :isValid="isValid('itemCode')"
                        :SearchTitle="this.$tc('ePharmacyItemsReceived.Item', 2)"
                        :GetValues="onCodeConditionOk"
                        :SearchFieldCode="'Code'"                
                    />
                </b-col>
                <b-col lg="4" md="4" sm="12">
                    <MdLookup
                        v-bind:Label="$tc('ePharmacyItemsReceived.Location', 1)"
                        v-bind:ModelCode="item.code"
                        v-bind:ModelDescription="item.locationDescription"
                        v-bind:Api="'PharmacyLocations/?FilterByEmployee=true&EmployeeCode='+this.$store.state.employeeCode"
                        v-bind:FieldCode="'code'"
                        v-bind:FieldDescription="'name'"
                        v-bind:Fields="locationBaseFields"
                        v-bind:RefCode="'location'"
                        v-bind:isRequired="true"
                        :isValid="isValid('location')"
                        :SearchTitle="this.$tc('ePharmacyItemsReceived.Location', 1)"
                        :GetValues="onCodeConditionOk"
                        :SearchFieldCode="'Code'"        
                    />
                </b-col>
                 <b-col lg="4" md="4" sm="12">
                    <MdEdit 
                        v-bind:Label="`${$t('ePharmacyItemsReceived.QtyReceived')} ${uomLabel}`"
                        v-bind:TypeProp="'number'" 
                        v-bind:Name="'quantityReceived'"
                        v-bind:Min="'0'"
                        v-bind:StepProp="'1'"
                        v-model.number="item.quantityReceived"
                        @change="changeHandler"
                        v-bind:isRequired="true"
                        :isValid="isValid('quantityReceived')"
                        v-bind:Id="'input_quantity'">                                     
                    </MdEdit>
                </b-col>                 
            </b-row>
            <b-row> 
                <b-col lg="4" md="4" sm="12">
                    <MdEdit 
                        v-bind:Label="$t('ePharmacyItemsReceived.UnitPrice')"
                        v-bind:TypeProp="'number'" 
                        v-bind:Name="'unitPrice'"
                        v-bind:Min="'0'"
                        v-bind:StepProp="'0.01'"
                        v-model="item.unitPrice"
                        @change="changeHandler" 
                        v-money-prefix                      
                        v-bind:isRequired="true"                       
                        :isValid="isValid('unitPrice')"
                        v-bind:Id="'input_unitPrice'">                                                        
                    </MdEdit>
                </b-col>
                <b-col lg="4" md="4" sm="12">
                    <MdEdit 
                        v-bind:Label="$t('ePharmacyItemsReceived.LotNo')"
                        v-bind:TypeProp="'text'" 
                        v-bind:Name="'lotNo'"
                        v-model="item.lotNo"
                        v-bind:isRequired="true"
                        :isValid="isValid('lotNo')"
                        v-bind:Id="'input_lotNo'">                                     
                    </MdEdit>
                </b-col>
                <b-col lg="4" md="4" sm="12">
                    <!--<MdEdit 
                        v-bind:Label="$t('ePharmacyItemsReceived.ExpirationDate')"
                        v-bind:TypeProp="'date'" 
                        v-bind:Name="'expirationDate'"
                        v-model="item.expirationDate"
                        v-bind:Min="'1900-01-01'"
                        v-bind:Max="'2200-12-31'"
                        v-bind:isRequired="true"
                        :isValid="isValid('expirationDate')"
                        v-bind:Id="'input_expirationDate'">                                     
                    </MdEdit>-->
                    <MdDateTime 
                        :Label="$t('ePharmacyItemsReceived.ExpirationDate')" 
                        :Model="item.expirationDate"                           
                        @input="item.expirationDate = $event"                            
                        :Id="'ItemReceivedExpirationDate'"
                        :Type="'date'"                    
                        :isRequired="true"                           
                        :isConfirm="false"
                        :ReadOnly="false">
                    </MdDateTime>
                </b-col>
                  <!--<b-col lg="3" md="3" sm="12">
                    <MdEdit 
                        v-bind:Label="$t('ePharmacyItemsReceived.Total')"
                        v-bind:TypeProp="'number'" 
                        v-bind:Name="'itemTotal'"
                        v-model="item.itemTotal"
                        v-bind:isReadOnly='true'
                        v-bind:Id="'input_itemTotal'">                                     
                    </MdEdit>
                </b-col>
                <b-col lg="3" md="3" sm="12">
                    <MdEdit 
                        v-bind:Label="$t('ePharmacyItemsReceived.MinOrder')"
                        v-bind:TypeProp="'number'" 
                        v-bind:Name="'minOrder'"
                        v-model="item.minOrder"
                        v-bind:isReadOnly='true'
                        v-bind:Id="'input_minOrder'">                                     
                    </MdEdit>
                </b-col>-->
            </b-row>
          
        </BaseModal>
    </div>
</template>

<script>
import Utils from "@/common/utils";
import validationMixin from '@/common/validationMixin';
import validationRules from '@/common/validationRules';
import ShowMessage from '@/components/messages/ShowMessage.js';

export default {
    name: 'eItemsReceivedEditDlg',
    mixins: [validationMixin, ShowMessage],

    props: {
        value: Object,
        visible: {
            type: Boolean,
            default: false
        },
        drugBaseFields: Array,
        drugAuxFields: Array,
        locationBaseFields: Array
    },

    data() {
        const defaultValue = {
            batchNo: null,
            description: null,
            expirationDate: null,
            itemCode: null,
            itemNo: null,
            itemTotal: null,
            location: null,
            locationDescription:null,
            lotNo: null,
            minOrder: null,
            quantityReceived: null,
            unitPrice: null
        }
        
        return {
            Total:0,
            MinOrder:0,
            modalId: 'itemReceivedDialogId',
            refresh: false,
            item: this.value ? JSON.parse(JSON.stringify(this.value)) : JSON.parse(JSON.stringify(defaultValue)),
            defaultValue: defaultValue,            
        }
    },

    watch: {
        visible(newVal) {
            if (newVal) {
                //this.$bvModal.show(this.modalId);
                this.emitCloseEvent= true;
            }
        },

        value(newVal) {
            if (newVal) {
                this.item = JSON.parse(JSON.stringify(newVal));
            } else {
                this.item = JSON.parse(JSON.stringify(this.defaultValue));
            }
        }
    },

    computed: {    
        okDisabled() {
            return !this.validate();
        },

        editMode() {
            return this.item !== null && this.item.itemNo !== null && this.item.itemNo !== undefined && this.item.itemNo > 0
        },

        uomLabel() {
            return this.item.uom ? `(${this.item.uom})` : '';
        }
    },

    updated(){
        if(this.visible){
            if(this.editMode){
                this.MinOrder = this.item.minOrder; 
                this.Total = this.item.itemTotal;                   
            }
        }
       
    },



    methods: {
        emitEventCancel() {
            this.emitCloseEvent= false;
            this.$emit('close');
        },  

        emitEventOK() {
            if (this.validate()) {  
                if(this.item.minOrder > this.item.quantityReceived){
                        this.$bvModal
                        .msgBoxConfirm(this.$t('DrugOrdersInbox.ItemReceivedConfirm'), {
                        title: this.$t('Msg.Confirm'),
                        okTitle: this.$t('Shared.TitleOK'),
                        cancelTitle: this.$t('Shared.BtnCancel'),
                        footerClass: "p-2",
                        titleClass: "modal-title modal-type-warning",
                        })
                        .then((value) => {
                        if (value) {
                            this.$emit('input', { ...this.item });
                            this.$emit('ok');
                        }
                    });
                }else{
                    this.$emit('input', { ...this.item });
                    this.$emit('ok');
                }                
                
            } else {
                if (!this.isValid('itemCode')) {
                    this.showMessage(this.$tc('Msg.Error'),this.invalidMessage('itemCode'),"errorAutoHide"); 
                }
                if (!this.isValid('location')) {
                    this.showMessage(this.$tc('Msg.Error'),this.invalidMessage('location'),"errorAutoHide"); 
                }
                if (!this.isValid('quantityReceived')) {
                    this.showMessage(this.$tc('Msg.Error'),this.invalidMessage('quantityReceived'),"errorAutoHide"); 
                }
                if (!this.isValid('unitPrice')) {
                    this.showMessage(this.$tc('Msg.Error'),this.invalidMessage('unitPrice'),"errorAutoHide"); 
                }
                if (!this.isValid('expirationDate')) {
                    this.showMessage(this.$tc('Msg.Error'),this.invalidMessage('expirationDate'),"errorAutoHide"); 
                }
                if (!this.isValid('lotNo')) {
                    this.showMessage(this.$tc('Msg.Error'),this.invalidMessage('lotNo'),"errorAutoHide"); 
                }
            }
        },

        onHidden() {
            if (this.emitCloseEvent) {
                this.$emit('close');
                this.emitCloseEvent= false;
            }
        },

        onCodeConditionOk(result) {
            var type = result.FieldName;
            
            if (type.indexOf('location') >= 0) {
                this.item.code = result.code
                this.item.location = result.code;
                this.item.locationDescription = result.description;
            } else if (type.indexOf('itemCode') >= 0) {
                this.item.itemCode = result.code.trim();
                this.item.description = result.description;

                if (result.AuxFields && result.AuxFields.length > 0) {
                    this.item.uom = result.AuxFields[0];
                    this.item.minOrder = result.AuxFields[2];
                    this.MinOrder = result.AuxFields[2];
                    this.item.unitPrice = result.AuxFields[3];

                   
                } else {
                    this.item.uom = null;
                    this.item.minOrder = null;
                    this.item.unitPrice = null;
                }
            }
        },

        changeHandler() {
            const quantityReceived = this.item.quantityReceived;
            const price = this.item.unitPrice;
            this.item.itemTotal = (quantityReceived * price).toFixed(2) ?? 0;
            this.Total = (quantityReceived * price).toFixed(2) ?? 0;
        },

        validate() {
            const rules = {
                expirationDate: [
                    validationRules.required(
                        this.$t("eItemsReceivedEdit.InvalidExpirationDateMsg")
                    ),                   
                    validationRules.greaterThanDate(
                        Utils.getCurrentDateTime(),
                        'YYYY-MM-DD',
                        this.$t("eItemsReceivedEdit.InvalidExpirationDateLessMsg")
                    ),
                ],
                location: [
                    validationRules.required(
                        this.$t("eItemsReceivedEdit.InvalidLocationMsg")
                    ),
                ],
                itemCode: [
                    validationRules.required(
                        this.$t("eItemsReceivedEdit.InvalidItemCodeMsg")
                    ),
                ],
                quantityReceived: [
                    validationRules.required(
                        this.$t("eItemsReceivedEdit.RequiredQuantityMsg")
                    ),
                    validationRules.greaterThan(0,
                        this.$t("eItemsReceivedEdit.InvalidQuantityMsg")
                    ),
                ],
                unitPrice: [
                    validationRules.required(
                        this.$t("eItemsReceivedEdit.InvalidUnitPriceMsg")
                    ),
                ],
                lotNo: [
                    validationRules.required(
                        this.$t("eItemsReceivedEdit.InvalidLotNoMsg")
                    ),
                ]
            }
            
            return this.validateFields(rules, this.item);
        },

        close() {
            this.emitEventCancel();
        }
    }
}
</script>